---
title: "Ersteinrichtung"
slug: initial-setup
description: "Schritt-für-Schritt-Anleitung zur Einrichtung von Standorten, externen Empfängern und Benutzern in hey circle."
keywords:
  - Ersteinrichtung
  - Standort
  - Benutzer
  - Rollen
  - externer Empfänger
  - Einrichtung
  - Shopify
---

## Voraussetzungen

- Rolle: Company Admin
- Ihr Unternehmen muss in hey circle angelegt sein

## Schritt für Schritt

Führen Sie die folgenden Schritte in dieser Reihenfolge aus:

### 1. Interne Standorte anlegen

1. Navigieren Sie im oberen Menü zu **Einstellungen → Scanstandorte**.
2. Klicken Sie auf **Neuen Standort anlegen** und geben Sie Name und Adresse ein.
3. Legen Sie mindestens einen Standort an — Benutzer mit der Rolle Scanner benötigen einen zugewiesenen Standort, bevor sie scannen können.

### 2. Externe Empfänger anlegen (optional)

1. Navigieren Sie im oberen Menü zu **Einstellungen → Empfänger**.
2. Klicken Sie auf **Neues externes Ziel anlegen** und füllen Sie Name und Adresse aus.
3. Externe Empfänger sind Empfänger außerhalb Ihrer eigenen Standorte, an die Sie Pakete versenden (z. B. Kunden oder Partner).

### 3. Benutzer anlegen und Rollen zuweisen

1. Navigieren Sie im oberen Menü zu **Einstellungen → Benutzer**.
2. Klicken Sie auf **Benutzer einladen** und geben Sie die E-Mail-Adresse des neuen Benutzers ein.
3. Wählen Sie die passende Rolle:

| Berechtigung | Company Admin | Company Manager | Scanner |
|---|---|---|---|
| Benutzer verwalten | ✓ | | |
| Integrationen verwalten (Shopify) | ✓ | | |
| Billing | ✓ | | |
| Standorte anlegen / bearbeiten | ✓ | ✓ | |
| Externe Empfänger anlegen / bearbeiten | ✓ | ✓ | |
| Analysen einsehen | ✓ | ✓ | |
| Pakete scannen (Senden / Empfangen) | ✓ | ✓ | ✓ |
| Inventarliste einsehen | ✓ | ✓ | ✓ |
| Verträge einsehen | ✓ | ✓ | |

4. Weisen Sie jedem Benutzer mit der Rolle Scanner mindestens einen internen Standort zu.

### 4. Shopify-Integration verbinden (optional)

Falls Sie Shopify nutzen: Navigieren Sie im oberen Menü zu **Einstellungen → Integrationen** und verbinden Sie Ihren Shop. Diese Einstellung steht nur Company Admins zur Verfügung.

### 5. Betrieb beginnen

Nach Abschluss der Einrichtung können Ihre Scanner-Benutzer sofort mit dem Scannen beginnen. Das Inventar entsteht automatisch durch Scan-Ereignisse — es gibt keinen separaten Schritt zur Inventaranlage. Weitere Informationen finden Sie im Konzeptartikel zum Inventar.

## Wenn es schiefgeht

- **Benutzer erhält keine Einladungs-E-Mail** — Prüfen Sie den Spam-Ordner. Falls die E-Mail nicht ankommt, löschen Sie die Einladung und senden Sie sie erneut.
- **Scanner kann nicht scannen** — Stellen Sie sicher, dass dem Benutzer mindestens ein interner Standort zugewiesen wurde.
- **Standort-Dropdown in Scanner-Ansicht leer** — Der Benutzer hat noch keinen zugewiesenen Standort. Weisen Sie ihn in der Benutzerverwaltung zu.
- Kontaktieren Sie uns: support@heycircle.com oder nutzen Sie die Feedback-Schaltfläche unten rechts auf dem Bildschirm.

## Verwandte Artikel

- [Pakete senden](/app/help?article=sending-a-package)
- [Pakete empfangen](/app/help?article=scanning-a-package)
- [Analysen lesen](/app/help?article=viewing-analytics)
